import React from 'react';
import { TQBRenderFlag } from '../../../../models/purchase-history/quick-books-export';

interface ITutorialWalkthroughButton {
  setQBRenderFlag: (value: TQBRenderFlag) => void;
}

const TutorialWalkthroughButton = (props: ITutorialWalkthroughButton) => {
  const { setQBRenderFlag } = props;
  return (
    <>
      <button
        type="button"
        onClick={() => {
          setQBRenderFlag('walkthrough');
        }}
      >
        Tutorial Walkthrough
      </button>
    </>
  );
};

export default TutorialWalkthroughButton;
